import { render, staticRenderFns } from "./HandedOver.vue?vue&type=template&id=31a4910c"
import script from "./HandedOver.vue?vue&type=script&lang=js"
export * from "./HandedOver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports